import { render, staticRenderFns } from "./FramesHomeView.vue?vue&type=template&id=ee4da1de&"
import script from "./FramesHomeView.vue?vue&type=script&lang=js&"
export * from "./FramesHomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports